import { render } from "./TosolaApp.vue?vue&type=template&id=3b6fa2e8&scoped=true"
import script from "./TosolaApp.vue?vue&type=script&lang=js"
export * from "./TosolaApp.vue?vue&type=script&lang=js"

import "./TosolaApp.vue?vue&type=style&index=0&id=3b6fa2e8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6fa2e8"]])

export default __exports__